import { api, bearer } from './client';
import type { components } from './generated/entitlements';

export type WaitingRequest = components['schemas']['WaitingRequestView'];
export type HubNotification = components['schemas']['HubNotificationView'];
export type NotificationsResponse = components['schemas']['HubNotificationsResponse'];

export function listNotifications(token: string, signal?: AbortSignal) {
  return api.GET('/notifications', { headers: bearer(token), signal });
}

export function markNotificationRead(token: string, id: string) {
  return api.POST('/notifications/{id}/read', { params: { path: { id } }, headers: bearer(token) });
}

export function markAllNotificationsRead(token: string) {
  return api.POST('/notifications/read-all', { headers: bearer(token) });
}
